import { Component, Renderer2, ViewChild } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { InventoryService } from "src/app/service/inventory.service";
import {
  FormGroup,
  FormBuilder,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatSelectModule } from "@angular/material/select";
import { CrmService } from "src/app/service/crm.service";
import { toast, NgxSonnerToaster } from "ngx-sonner";
import {
  alertModal,
  alertModalDecline,
  alertModalWithoutConfirm,
} from "../../helpers/alert";
import { ForwardReqComponent } from "../shared/forward-req/forward-req.component";
import { ForwardServiceReqComponent } from "../shared/forward-service-req/forward-service-req.component";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NoDataComponent } from "../shared/no-data/no-data.component";
import { ZXingScannerModule } from "@zxing/ngx-scanner";
import { FormsModule } from "@angular/forms";
import gsap from "gsap";
import { AnimatedSvgComponent } from "../shared/animate-svg/animated-svg.component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { environment } from "src/environments/environment";

interface Request {
  value: string;
  viewValue: string;
}

interface ApprovedInventory {
  value: string;
  viewValue: string;
}

interface ApprovedNewInventory {
  value: string;
  viewValue: string;
}

interface ApprovedServiceRequest {
  value: string;
  viewValue: string;
}

interface ApprovedReturn {
  value: string;
  viewValue: string;
}

import { isHrOrItAdminDept } from 'src/app/constants/departments';
@Component({
    selector: "app-inventory-dashboard",
    imports: [
        RouterLink,
        ReactiveFormsModule,
        CommonModule,
        MatFormFieldModule,
        MatDatepickerModule,
        FormsModule,
        MatInputModule,
        MatButtonModule,
        MatSelectModule,
        ZXingScannerModule,
        NgxSonnerToaster,
        ForwardReqComponent,
        ForwardServiceReqComponent,
        NoDataComponent,
        AnimatedSvgComponent,
        InfiniteScrollModule,
    ],
    templateUrl: "./inventory-dashboard.component.html",
    styleUrls: ["./inventory-dashboard.component.css", "../styles/inventory.css"]
})
export class InventoryDashboardComponent {
  viewAll: boolean = false;

  viewApprovedUser: boolean = false;
  uploadAssetImageForm: FormGroup;
  selectedFiles: any[] = [];
  extendRequestForm: FormGroup;
  forwardRequestForm: FormGroup;
  forwardNewRequestForm: FormGroup;
  overdueExtendForm: FormGroup;
  declineReasonForm: FormGroup;
  chargingReminderForm: FormGroup;
  scanRequestForm: FormGroup;
  constructor(
    private inventoryService: InventoryService,
    private renderer: Renderer2,
    private fb: FormBuilder,
    private crmService: CrmService,
    private snackBar: MatSnackBar,
    private router: Router
  ) {
    this.uploadAssetImageForm = this.fb.group({
      assetImage: [],
    });
    this.extendRequestForm = this.fb.group({
      extendTill: [],
    });

    // Forward Request Form Group
    this.forwardRequestForm = this.fb.group({
      maximumCost: ["", Validators.required],
      comment: ["", Validators.required],
      selectedAdmin: ["", Validators.required],
    });

    this.declineReasonForm = this.fb.group({
      rejectionReason: ["", Validators.required],
    });

    this.chargingReminderForm = this.fb.group({
      chargingBatteryType: ["", Validators.required],
      firstContactDate: ["", Validators.required],
      reason: ["", Validators.required],
    });

    this.scanRequestForm = this.fb.group({
      assetName: [""],
      productId: [""],
      location: [""],
    });
  }

  disableTyping(event: KeyboardEvent) {
    event.preventDefault();
  }

  scannerEnabled: boolean = false;
  scannedProductName: string = "";
  scannedProductId: string = "";

  isShimmerLoading: boolean = true;
  shimmerLoadingValue = ([] = [1, 2, 3, 4, 5]);

  initializeAnimatedCircles() {
    const circlePositions = [
      { x: 79.11, y: 70.19, opacity: 0.2 },
      { x: 78.51, y: 39.99, opacity: 0.1 },
      { x: 91.95, y: 54.49, opacity: 0.2 },
      { x: 89.08, y: 15.42, opacity: 0.4 },
      { x: 95.13, y: 38.37, opacity: 0.1 },
      { x: 70.05, y: 79.86, opacity: 0.2 },
      { x: 91.95, y: 4.14, opacity: 0.3 },
      { x: 96.79, y: 6.56, opacity: 0.3 },
      { x: 11.92, y: 9.67, opacity: 0.2 },
      { x: 11.31, y: 39.88, opacity: 0.1 },
      { x: 24.76, y: 25.38, opacity: 0.2 },
      { x: 21.89, y: 64.45, opacity: 0.4 },
      { x: 27.93, y: 41.49, opacity: 0.1 },
      { x: 2.85, y: 0, opacity: 0.2 },
      { x: 24.76, y: 75.72, opacity: 0.3 },
      { x: 29.59, y: 73.31, opacity: 0.3 },
    ];

    // Create circles for all .assets-content containers
    document.querySelectorAll(".assets-content").forEach((container) => {
      const circlesContainer = container.querySelector(".animated-circles");

      circlePositions.forEach((pos, i) => {
        const circle = document.createElement("div");
        circle.className = "animated-circle";
        circle.style.left = `${pos.x}%`;
        circle.style.top = `${pos.y}%`;
        circle.style.opacity = pos.opacity.toString();
        circle.style.animationDelay = `${i * 0.2}s`;
        circlesContainer.appendChild(circle);
      });
    });
  }

  openScannerModal() {
    this.scannerEnabled = true;
    const modalElement = document.getElementById("qrScannerModal");
    if (modalElement) {
      modalElement.classList.add("show");
      modalElement.style.display = "block";
      modalElement.style.backgroundColor = "rgba(0,0,0,0.5)";
    }
    setTimeout(() => {
      this.scannerEnabled = true;
    }, 100);
  }

  closeScannerModal() {
    this.scannerEnabled = false;
    const modalElement = document.getElementById("qrScannerModal");
    if (modalElement) {
      modalElement.classList.remove("show");
      modalElement.style.display = "none";
    }
  }

  onScroll() {
    console.log(
      "📦 Scrolled! Current:",
      this.overdueAssets.length,
      "Total:",
      this.totalOverdueAssets
    );
    const totalLoaded = this.overdueAssets.length;
    if (totalLoaded >= this.totalOverdueAssets) return;

    this.currentPageNume++;
    this.overdueAssetInventories();
  }

  onAssignScroll() {
    console.log("Scrolled! Current Inventory Length:", this.inventory.length);
    const totalLoaded = this.inventory.length;
    if (totalLoaded >= this.totalAssigned) return;

    this.currentPageNume++;
    this.getAssignedInventoryData();
  }

  handleScanSuccess(data: string) {
    this.scannerEnabled = false;
    this.closeScannerModal();
    this.scannedProductId = data;
    if (this.scannedProductId) {
      console.log("Extracted Product ID:", this.scannedProductId);
      this.getInventoryData();
      this.initializeAnimatedCircles();
    } else {
      console.error("Product ID not found");
    }
  }

  serviceReqId: any;
  openForwardService(requestId: any) {
    console.log("Request ID", requestId);
    // this.selectedInventory = null;
    this.serviceReqId = requestId;
    const forwardReqComponent = this.forwardReqComponentRef;
    if (forwardReqComponent) {
      forwardReqComponent.forwardReqReset();
    }
  }

  openSelectReqModal() {
    const modalElement = document.getElementById("selectReqModal");
    if (modalElement) {
      this.renderer.addClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "block");
    }
  }

  closeSelectReqModal() {
    const modalElement = document.getElementById("selectReqModal");
    if (modalElement) {
      this.renderer.removeClass(modalElement, "show");
      this.renderer.setStyle(modalElement, "display", "none");
    }
  }

  openServiceRequestModal() {
    this.router.navigate(["/inventory/service-request"], {
      queryParams: { openServiceReq: "true", productId: this.scannedProductId },
    });
  }

  navigateToReturnReq() {
    this.router.navigate(["/inventory/return-request"]);
  }
  navigateToInventoryReq() {
    this.router.navigate(["/inventory/inventory-request"]);
  }
  navigateToNewInventoryReq() {
    this.router.navigate(["/inventory/new-inventory-request"]);
  }
  navigateToServiceRequest() {
    this.router.navigate(["/inventory/service-request"]);
  }
  openInventoryRequestModal() {
    this.router.navigate(["/inventory/inventory-request"], {
      queryParams: {
        openInventoryReq: "true",
        productId: this.scannedProductId,
      },
    });
  }

  openManualServiceReqModal() {
    this.router.navigate(["/inventory/service-request"], {
      queryParams: { openServiceReq: "true" },
    });
  }
  openManualInventoryReqModal() {
    this.router.navigate(["/inventory/inventory-request"], {
      queryParams: { openInventoryReq: "true" },
    });
  }

  inventoryy: any[] = [];
  totalInventory: number;
  inventoryAccessory: any;
  barCodeImg: any;
  searchQuery: string;
  isAllInventory: boolean = false;
  productDetails: any;
  currentPageNume = 1;
  currentLimit = 100;
  getInventoryData() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      available: true,
    };

    this.inventoryService.getAllInventory(field).subscribe(
      (response: any) => {
        this.inventoryy = response.data.records.reverse();
        this.totalInventory = response.data.totalCounts;

        this.productDetails = this.inventoryy.find(
          (item) => item.productId === this.scannedProductId
        );

        if (this.productDetails) {
          console.log("Matched Product Details:", this.productDetails);
          this.openSelectReqModal();
          this.prefillForm();
        } else {
          console.error("Product not found.");
        }
      },
      (error) => {
        console.error("Error", error);
      }
    );
  }

  prefillForm() {
    if (this.productDetails) {
      this.scanRequestForm.patchValue({
        assetName: this.productDetails.name,
        productId: this.productDetails.productId,
        location: this.productDetails.location,
      });
    }
  }

  onScanReqSubmit() {
    console.log("Form submitted:", this.scanRequestForm.value);
  }

  defaultPendingRequestType: string = "Inventory Request";
  userDepartment: string | null = null;
  showUserDashboard = false;
  showAdminRequest = false;
  today: string;
  ngOnInit() {
    const savedState = localStorage.getItem("isSubmittedMap");
    this.isSubmittedMap = savedState ? JSON.parse(savedState) : {};
    this.getInventoryData();
    this.getAdminUsersList();
    this.overdueAssetInventories();
    this.getAssignedInventoryData();
    this.onFilterPendingRequest(this.defaultPendingRequestType);
    this.onFilterApprovedRequest(this.defaultPendingRequestType);
    this.getInventoryRequest();
    this.getNewInventory();
    this.getServiceRequestData();
    this.getInventoryReturnRequest();
    this.getExtendData();
    this.inventoryOverview();
    this.assetReturnReq();
    this.showNewInventoryRequestTable = true;
    this.getApprovedNewInventory();
    this.userDepartment = localStorage.getItem("department");
    this.showUserDashboard = isHrOrItAdminDept(this.userDepartment);
    this.showAdminRequest = this.userDepartment === "ADMIN";

    const now = new Date();
    this.today = now.toISOString().split("T")[0];
    this.allCount();
  }

  assignedInventoryId: string;
  selectedInventoryIndex: number | null = null;
  openReturn(assignedInventoryId: string, index: number) {
    this.assignedInventoryId = assignedInventoryId;
    this.selectedInventoryIndex = index;

    this.uploadAssetImageForm.reset();
    this.selectedFiles = [];

    this.uploadAssetImageForm.get("assetImage").enable();
    this.showForwardSuccess = false;
  }

  overdueAssignedInventoryId: string;
  selectedOverdueIndex: number | null = null;
  openOverdueExtend(overdueAssignedInventoryId: string, index: number) {
    this.overdueAssignedInventoryId = overdueAssignedInventoryId;
    this.selectedOverdueIndex = index;
  }

  removeFile(file: any) {
    const index = this.selectedFiles.indexOf(file);
    if (index > -1) {
      this.selectedFiles.splice(index, 1);
    }
    if (this.selectedFiles.length < 4) {
      this.uploadAssetImageForm.get("assetImage").enable();
    }
  }

  onFileSelected(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;

      if (files.length + this.selectedFiles.length > 4) {
        alert("You can only upload a maximum of 4 files.");
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedFiles.push({
            file: file,
            name: file.name,
            size: (file.size / 1024).toFixed(2) + " KB",
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }

      console.log("Selected Files", this.selectedFiles);

      if (this.selectedFiles.length >= 4) {
        this.uploadAssetImageForm.get("assetImage").disable();
      }
    }
  }

  onApprovedSubmitImages(event: any) {
    if (event.target.files && event.target.files.length > 0) {
      const files = event.target.files;

      if (files.length + this.selectedFiles.length > 4) {
        alert("You can only upload a maximum of 4 files.");
        return;
      }

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.selectedFiles.push({
            file: file,
            name: file.name,
            size: (file.size / 1024).toFixed(2) + " KB",
            preview: e.target.result,
          });
        };
        reader.readAsDataURL(file);
      }

      console.log("Selected Files", this.selectedFiles);

      if (this.selectedFiles.length >= 4) {
        this.uploadAssetImageForm.get("assetImage").disable();
      }
    }
  }

  showForwardSuccess = false;
onReturnSubmit() {
  console.log(this.uploadAssetImageForm.value);

  if (this.selectedFiles.length === 0) {
    return alertModalWithoutConfirm("warning", `Please upload at least 1 image.`);
  }

  const formData = new FormData();
  formData.append("assignedInventoryId", this.assignedInventoryId);
  formData.append("redirectUrl", `${environment.redirectUrl}#/inventory/return-request`);

  this.selectedFiles.forEach((fileData: any, index: number) => {
    formData.append(`files[${index}]`, fileData.file, fileData.name);
  });

  this.inventoryService.addAssignedReturn(formData).subscribe(
    (res) => {
      alertModal("success", "Your return request has been submitted!");
      console.log("Return request submitted");

      if (
        this.selectedInventoryIndex !== undefined &&
        this.overdueAssets &&
        this.overdueAssets[this.selectedInventoryIndex]
      ) {
        const selected = this.overdueAssets[this.selectedInventoryIndex];

        // ✅ Only update return flag and disable extend
        selected.isReturnRequested = true;

        // (do NOT change extend text flag)
        selected.isExtendRequested = selected.isExtendRequested || false;

        // ✅ Force re-render
        this.overdueAssets = [...this.overdueAssets];
      }
    },
    (err) => {
      console.error("Return request failed", err);
    }
  );
}



  onOverdueSubmit(overdueAssetInv) {
    console.log(this.uploadAssetImageForm.value);

    // if (this.selectedFiles.length === 0) {
    //     return alertModalWithoutConfirm("warning", `Please upload at least 1 image.`);
    // }

    const formData = new FormData();
    formData.append("assignedInventoryId", overdueAssetInv.assignedInventoryId); // Use the ID from the clicked asset

    const images = overdueAssetInv.images;
    console.log(images);
    images.forEach((image, index) => {
      formData.append(`files[${index}]`, image.file, image.name);
    });

    this.inventoryService.addAssignedReturn(formData).subscribe(
      (res) => {
        this.showForwardSuccess = true;
        this.overdueAssets = this.overdueAssets.filter(
          (asset) =>
            asset.assignedInventoryId !== overdueAssetInv.assignedInventoryId
        );
        this.totalOverdueAssets--;
      },
      (err) => {
        console.error("failed", err);
      }
    );
  }

  isSubmittedMap: { [key: string]: boolean } = {};

  isSubmitted: boolean = false;
  subImg = [];
  onApprovedSubmitImg() {
    console.log("Request ID:", this.inventoryRequestId);
    console.log(this.uploadAssetImageForm.value);

    if (this.selectedFiles.length === 0) {
      return alertModalWithoutConfirm(
        "warning",
        `Please upload atleast 1 image.`
      );
    }

    const formData = new FormData();
    formData.append("requestId", this.inventoryRequestId);
    formData.append("requestType", "Inventory Request");

    this.selectedFiles.forEach((fileData: any, index: number) => {
      formData.append(`files[${index}]`, fileData.file, fileData.name);
    });

    this.inventoryService.addApprovedImages(formData).subscribe(
      (res) => {
        this.showForwardSuccess = true;
        this.subImg = res["data"].location;
        this.isSubmittedMap[this.inventoryRequestId] = true;
      },
      (err) => {
        console.error("failed", err);
      }
    );
  }

  @ViewChild(ForwardReqComponent) forwardReqComponentRef!: ForwardReqComponent;
  openForward(requestId: any) {
    console.log("Request ID", requestId);
    this.newInvReqId = requestId;
    const forwardReqComponent = this.forwardReqComponentRef;
    if (forwardReqComponent) {
      forwardReqComponent.forwardReqReset();
    }
  }

  onRequestForwarded(forwardedRequestId: string) {
    this.newInventories = this.newInventories.filter(
      (req) => req.requestId !== forwardedRequestId
    );
  }

  onServiceForwarded(forwardedRequestId: string) {
    this.serviceRequest = this.serviceRequest.filter(
      (req) => req.requestId !== forwardedRequestId
    );
    this.totalService = this.serviceRequest.length;
    console.log(this.serviceRequest);
  }

  setInventoryRequestId(requestId: string): void {
    this.selectedFiles = [];
    this.inventoryRequestId = requestId;
    console.log("Request ID set for submission:", this.inventoryRequestId);
  }
  formatExtendDate(date: Date): { day: number; month: number; year: number } {
    return {
      day: date.getDate(),
      month: date.getMonth() + 1,
      year: date.getFullYear(),
    };
  }

onRequestExtend() {
  const extendValue = { ...this.extendRequestForm.value };
  const extendTill = new Date(extendValue.extendTill);
  const formattedExtendDate = this.formatExtendDate(extendTill);

  const extendRequest = {
    assignedInventoryId: this.assignedInventoryId,
    extendTill: formattedExtendDate,
    redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=extend`,
  };

  this.inventoryService.assignedExtendRequest(extendRequest).subscribe(
    (response) => {
      alertModal("success", "Your request for extend has been submitted!");
      console.log("Extend request submitted");

      if (
        this.selectedInventoryIndex !== undefined &&
        this.overdueAssets &&
        this.overdueAssets[this.selectedInventoryIndex]
      ) {
        const selected = this.overdueAssets[this.selectedInventoryIndex];

        // ✅ Only update extend flag and disable return
        selected.isExtendRequested = true;

        // (do NOT change return text flag)
        selected.isReturnRequested = selected.isReturnRequested || false;

        // ✅ Force re-render
        this.overdueAssets = [...this.overdueAssets];
      }
    },
    (error) => {
      console.error("Extend request failed", error);
    }
  );
}





  // Overdue Extend
  onRequestOverdueExtend() {
    const extendValue = {
      ...this.extendRequestForm.value,
    };
    const extendTill = new Date(extendValue.extendTill);
    const formattedExtendDate = this.formatExtendDate(extendTill);
    const extendRequest = {
      assignedInventoryId: this.assignedInventoryId,
      extendTill: {
        day: extendTill.getDate(),
        month: extendTill.getMonth() + 1,
        year: extendTill.getFullYear(),
      },
       redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=extend`, 
    };

    this.inventoryService
      .overdueExtendRequest(extendRequest)
      .subscribe((response) => {
        console.log("submitted");
        this.overdueAssetInventories();
      });
  }

  redirectToAssigned() {
    this.router.navigate(["/inventory/inventories"], {
      queryParams: { filter: "onlyAssigned" },
    });
  }

  selectedApprovedType: string = "";
  navigateToApproved() {
    let routePath = "";

    switch (this.selectedApprovedType) {
      case "New Inventory Request":
        routePath = "/inventory/new-inventory-request";
        break;
      case "Service Request":
        routePath = "/inventory/service-request";
        break;
      case "Inventory Request":
      default:
        routePath = "/inventory/inventory-request";
        break;
    }

    this.router.navigate([routePath], {
      queryParams: { filter: "Approved Request" },
    });
  }

  selectedPendingType: string = "";
  navigateToPending() {
    let routePath = "";

    switch (this.selectedPendingType) {
      case "New Inventory Request":
        routePath = "/inventory/new-inventory-request";
        break;
      case "Service Request":
        routePath = "/inventory/service-request";
        break;
      case "Inventory Request":
      default:
        routePath = "/inventory/inventory-request";
        break;
    }

    this.router.navigate([routePath], {
      queryParams: { filter: "Pending Request" },
    });
  }

  //Assigned Assets Listings
  inventory: any[] = [];
  totalAssigned: any;
  getAssignedInventoryData() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getAssignInv(field).subscribe(
      (response: any) => {
        this.inventory = response["data"].records.reverse();
        this.totalAssigned = response["data"].totalCounts;
      },
      (error) => {
        console.error("Error", error);
      }
    );
  }
  requests: Request[] = [
    { value: "Inventory Request", viewValue: "Inventory Request" },
    { value: "Service Request", viewValue: "Service Request" },
    { value: "New Inventory Request", viewValue: "New Inventory Request" },
    // { value: "Extend Request", viewValue: "Extend Request" },
    // { value: "Return Request", viewValue: "Return Request" },
  ];

  approvedInventory: ApprovedInventory[] = [
    { value: "Inventory Request", viewValue: "Inventory Request" },
  ];

  approvedNewInventory: ApprovedNewInventory[] = [
    { value: "New Inventory Request", viewValue: "New Inventory Request" },
  ];

  approvedServiceRequest: ApprovedServiceRequest[] = [
    { value: "Service Request", viewValue: "Service Request" },
  ];

  approvedReturn: ApprovedReturn[] = [
    { value: "Return Request", viewValue: "Return Request" },
  ];

  showUrgency: boolean = false;
  showReturnHead: boolean = false;
  showServicePending: boolean = false;
  onRequestSelect(value: string): void {
    this.selectedPendingType = value;
    console.log("Selected value:", value);
    this.onFilterPendingRequest(value);
  }

  onApprovedReqSelect(value: string) {
    this.selectedApprovedType = value;
    console.log("Selected value:", value);
    this.onFilterApprovedRequest(value);
  }


  pendingReq = [];
  totalPending: any;
  onFilterPendingRequest(
    requestType: string,
    pageNum: number = 1,
    limit: number = 100
  ) {
    const getPendingReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.showUrgency = requestType === "New Inventory Request";
    this.showReturnHead = requestType === "Return Request";
    this.showServicePending = requestType === "Service Request";

    this.inventoryService
      .getPendingRequest(getPendingReqValue)
      .subscribe((response) => {
        console.log("Pending Request");
        this.pendingReq = response["data"].records;
        this.totalPending = response["data"].totalCounts;
      });
  }

  approveInv = [];
  totalApproved = [];
  showServiceApproved: boolean = false;
  showAssetType: boolean = false;
  showApprovedReturn: boolean = false;

  onFilterApprovedRequest(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    const getApprovedReqValue: any = {
      requestType: requestType,
      pageNum: pageNum,
      limit: limit,
    };
    if (this.showUserDashboard) {
      getApprovedReqValue.isAll = "true";
    }
    const field: any = {};
    this.showAssetType = requestType === "New Inventory Request";
    this.showServiceApproved = requestType === "Service Request";
    this.showApprovedReturn = requestType === "Return Request";
    this.inventoryService
      .getApprovedRequest(getApprovedReqValue)
      .subscribe((response) => {
        console.log("Approved Request", response);
        // alertModalWithoutConfirm("success", "Yor Product has been Deleted!")
        // this.approveInv = response["data"].records;
        this.totalApproved = response["data"].totalCounts;
        this.approveInv = response["data"].records.map((record: any) => ({
          ...record,
          submittedImagesByUser: record.submittedImagesByUser || [],
        }));
      });
  }

  overdueAssetInv: any;
  openOverdueAsset(index: number) {
    this.overdueAssetInv = this.overdueAssets[index];
    console.log({ overdueAssetName: this.overdueAssetInv });
  }

  overdueAssets = [];
  totalOverdueAssets: any;
  overdueAssetInventories() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.inventoryService.getOverdueAssets(field).subscribe((response) => {
      const newData = response["data"].requests.map((asset) => ({
        ...asset,
        images: asset.images || [],
      }));

      // Append new data instead of replacing
      if (this.currentPageNume === 1) {
        this.overdueAssets = newData;
      } else {
        this.overdueAssets = [...this.overdueAssets, ...newData];
      }

      this.totalOverdueAssets = response["data"].totalCounts;
      console.log(
        "Loaded:",
        this.overdueAssets.length,
        "of",
        this.totalOverdueAssets
      );
    });
  }

  //ADMIN DASHBOARD
  viewAssigned: boolean = false;
  viewApproved: boolean = false;
  viewPending: boolean = false;
  viewAAssetReturn: boolean = false;
  //Inventory Request Listing
  inventoriesReq = [];
  totalInventoryRequest: any;
  showInventoryRequestTable: boolean = false;
  getInventoryRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };

    this.inventoryService
      .getAllInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);

        const newRecords = response["data"].records;

        if (this.currentPageNume === 1) {
          this.inventoriesReq = newRecords;
        } else {
          this.inventoriesReq = [...this.inventoriesReq, ...newRecords];
        }

        this.totalInventoryRequest = response["data"].totalCounts;
        this.isShimmerLoading = false;
      });
  }

  inventoriesApprReq = [];
  totalInventoryApprRequest: any;
  selectedHRApprovedType: string = "";
  getApprovedInventoryRequest() {
    this.selectedApprovedType = "Inventory Request";
    const field: any = {
      pageNum: 1,
      limit: 100,
      status: "Approved",
    };
    this.inventoryService
      .getAllInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);
        this.inventoriesApprReq = response["data"].records;
        this.totalInventoryApprRequest = response["data"].totalCounts;
        this.isShimmerLoading = false;
        this.showNewInventoryRequestTable = false;
        this.showInventoryRequestTable = true;
        this.showService = false;
        this.showReturn = false;
      });
  }

  //New Inventory Request Listing
  newInventories = [];
  totalNewInventory: any;

  getNewInventory() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService
      .getNewInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);
        const newRecords = response["data"].records;
        if (this.currentPageNume === 1) {
          this.newInventories = newRecords;
        } else {
          this.newInventories = [...this.newInventories, ...newRecords];
        }
        this.totalNewInventory = response["data"].totalCounts;
      });
  }
  onNewInvScroll() {
    console.log(
      "Scrolled! Current Inventory Length:",
      this.newInventories.length
    );
    const totalLoaded = this.newInventories.length;
    if (totalLoaded >= this.totalInventoryRequest) return;
    this.currentPageNume++;
    this.getNewInventory();
  }

  newApprInventories = [];
  totalApprNewInventory: any;
  getApprovedNewInventory() {
    this.selectedApprovedType = "New Inventory Request";
    const field: any = {
      pageNum: 1,
      limit: 100,
      status: "Approved",
    };
    this.inventoryService
      .getNewInventoryRequest(field)
      .subscribe((response) => {
        console.log("Response", response);
        this.newApprInventories = response["data"].records;
        this.totalApprNewInventory = response["data"].totalCounts;
        this.showNewInventoryRequestTable = true;
        this.showInventoryRequestTable = false;
        this.showService = false;
        this.showReturn = false;
      });
  }

  //Service Request Listing
  serviceRequest = [];
  totalService: any;
  showService: boolean = false;
  getServiceRequestData() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getServiceRequest(field).subscribe((res) => {
      const newRecords = res["data"].records;
      if (this.currentPageNume === 1) {
        this.serviceRequest = newRecords;
      } else {
        this.serviceRequest = [...this.serviceRequest, ...newRecords];
      }
      this.totalService = res["data"].totalCounts;
    });
  }

  onServiceScroll() {
    console.log(
      "Scrolled! Current Inventory Length:",
      this.serviceRequest.length
    );
    const totalLoaded = this.serviceRequest.length;
    if (totalLoaded >= this.totalService) return;
    this.currentPageNume++;
    this.getServiceRequestData();
  }

  serviceApprRequest = [];
  totalApprService: any;
  getApprovedServiceRequestData() {
    this.selectedApprovedType = "Service Request";
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: "Approved",
    };
    this.inventoryService.getServiceRequest(field).subscribe((res) => {
      this.serviceApprRequest = res["data"].records;
      this.totalApprService = res["data"].totalCounts;
      this.showService = true;
      this.showNewInventoryRequestTable = false;
      this.showInventoryRequestTable = false;
      this.showReturn = false;
    });
  }

  returnInv = [];
  totalReturn: any;
  getInventoryReturnRequest() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getInvReturnRequest(field).subscribe((response) => {
      console.log("RETURN REQUEST", response);
      // this.returnInv = response["data"].records;
      const newRecords = response["data"].records;
      if (this.currentPageNume === 1) {
        this.returnInv = newRecords;
      } else {
        this.returnInv = [...this.returnInv, ...newRecords];
      }
      this.totalReturn = response["data"].totalCounts;
    });
  }

  onInventoryReturnScroll() {
    console.log("Scrolled! Current Inventory Length:", this.returnInv.length);
    const totalLoaded = this.returnInv.length;
    if (totalLoaded >= this.totalReturn) return;
    this.currentPageNume++;
    this.getInventoryReturnRequest();
  }

  showReturn: boolean = false;
  returnApprInv = [];
  totalApprReturn: any;
  getApprovedReturnRequest() {
    this.selectedApprovedType = "Return Request";
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: "Approved",
    };
    this.inventoryService.getInvReturnRequest(field).subscribe((response) => {
      console.log("RETURN REQUEST", response);
      this.returnApprInv = response["data"].records;
      this.totalApprReturn = response["data"].totalCounts;
      this.showReturn = true;
      this.isShimmerLoading = false;
      this.showNewInventoryRequestTable = false;
      this.showInventoryRequestTable = false;
      this.showService = false;
    });
  }

navigateToHRApproved() {
  let route = "";
  let filterValue = "Approved Request"; 

  switch (this.selectedApprovedType) {
    case "Inventory Request":
      route = "/inventory/inventory-request";
      break;
    case "New Inventory Request":
      route = "/inventory/new-inventory-request";
      break;
    case "Service Request":
      route = "/inventory/service-request";
      break;
    case "Return Request":
      route = "/inventory/return-request";
      filterValue = "HR approved return"; 
      break;
    default:
      return;
  }

  this.router.navigate([route], {
    queryParams: { filter: filterValue },
  });
}



  

  adminUsers: { value: string; viewValue: string; id: string }[] = [];
  getAdminUsersList() {
    const department = "ADMIN";
    const loggedInUsername = localStorage.getItem("username");
    const loggedInUserId = localStorage.getItem("guestID");
    this.crmService.getAnyUsers(department).subscribe(
      (res) => {
        let data = res["data"];
        this.adminUsers = data.map((adminUser) => {
          return {
            value: adminUser.userName,
            viewValue: adminUser.userName,
            id: adminUser._id,
          };
        });
      },
      (err) => {
        console.log(err);
      }
    );
  }

  //Forward Request Form Submit
  selectedInventory: any = {};
  selectedSerInventory: any = {};

  // Forward New Inventory Request
  // selectedNewInventory: any = {}

  extendInv = [];
  totalExtend: any;
  LoadingShimmer: boolean = false;
  getExtendData() {
    const field: any = {
      pageNum: 1,
      limit: 100,
    };
    this.inventoryService.getExtendRequest(field).subscribe((response: any) => {
      this.extendInv = response.data.records;
      console.log("Extend Request", response);
      // const newRecords = response["data"].records;
      // if (this.currentPageNume === 1) {
      //   this.extendInv = newRecords;
      // } else {
      //   this.extendInv = [...this.extendInv, ...newRecords];
      // }
      this.totalExtend = response.data.totalCounts;
    });
  }

  totalAssets: any;
  rentalAssets: any;
  availableAsset: any;
  wentForDemo: any;
  totalQuantity: any; 
  rentalQuantity: any;
  availableQuantity: any;
  demoQuantity: any;
  inventoryOverview() {
    this.LoadingShimmer = true;
    this.inventoryService.getInventoryOverview().subscribe((response) => {
      console.log("Overview");
      this.totalAssets = response["data"].totalAssets;
      this.totalQuantity = response["data"].totalAssetsQuantity;
      this.rentalAssets = response["data"].rentalAssets;
      this.availableAsset = response["data"].availableAsset;
      this.wentForDemo = response["data"].wentForDemo;
      this.rentalQuantity = response["data"].rentalAssetsQuantity;
      this.availableQuantity = response["data"].availableAssetsQuantity;
      this.demoQuantity = response["data"].wentForDemoQuantity;
      this.LoadingShimmer = false;
    });
  }

  approveCount: any;
  pendingCount: any;
allCount(){
  this.LoadingShimmer = true;
    this.inventoryService.getAllCounts().subscribe((response) => {
      console.log("All Count", response);
      this.approveCount = response["data"].totalApprovedRequests;
      this.pendingCount = response["data"].totalPendingRequests;
      this.LoadingShimmer = false;
    });
}
  previewReturnImg: any;
  openReturnPreviewSlider(index: number) {
    this.previewReturnImg = this.returnInv[index];
    this.uploadAssetImageForm.reset();
    this.declineReasonForm.reset();
    this.showDeclineForm = false;
  }



  isProcessingAction: boolean = false;
  // ASSET RETURN REQUEST ACCEPT
acceptReturnRequest(requestId: any) {
  this.isProcessingAction = true;

  const acceptRequest = {
    action: "Accept",
    requestId: requestId,
    requestType: "Return Request",
    redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Return Request`,
  };

  this.inventoryService.adminAction(acceptRequest).subscribe(
    (response) => {
      console.log("called");
      this.showDeclineForm = false;

      alertModalWithoutConfirm("success", "Request has been Approved!");

      this.getInventoryReturnRequest();

      setTimeout(() => {
        this.isProcessingAction = false;
      }, 1000); 
    },
    (error) => {
      this.isProcessingAction = false;
    }
  );
}


  // ASSET RETURN REQUEST REJECT
rejectReturnRequest(requestId: any) {
  this.isProcessingAction = true;

  const rejectValue = {
    ...this.declineReasonForm.value,
  };

  const getRejectValue = {
    rejectionReason: rejectValue.rejectionReason,
    action: "Rejected",
    requestId: requestId,
    requestType: "Return Request",
    redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Declined Return Request`,
  };

  this.inventoryService.adminAction(getRejectValue).subscribe(
    (response) => {
      console.log("Decline request", response);
      alertModalWithoutConfirm(
        "success",
        "Return Request has been declined successfully."
      );
 
      this.getInventoryReturnRequest();
      this.totalReturn = Math.max(0, this.totalReturn - 1);
      const modalElement = document.getElementById("inventoryReturnReqModal");
    if (modalElement) {
      modalElement.style.display = "none";        
      modalElement.classList.remove("show");     
      document.body.classList.remove("modal-open"); 
      
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    }

      setTimeout(() => {
        this.isProcessingAction = false;
      }, 1000);
    },
    (error) => {
      this.isProcessingAction = false;
    }
  );
}

  showNewInventoryRequestTable: boolean = false;
  // ACCEPT INVENTORY REQUEST
  inventoryRequestId: any;
  acceptInvRequest(requestId: any) {
    this.inventoryRequestId = requestId;
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Inventory Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/inventory-request?filter=Approved Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      console.log("called");
      alertModalWithoutConfirm("success", "Request has been Approved!");
      // window.location.reload();
      // this.snackBar.open("Accepted", "OK");
      this.getInventoryRequest();
    });
  }

  // REJECT INVENTORY REQUEST
  async declineInvRequest(requestId: any) {
    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        action: "Rejected",
        requestId: requestId,
        requestType: "Inventory Request",
       redirectUrl: `${environment.redirectUrl}#/inventory/inventory-request?filter=Declined Request`,

      };
      this.inventoryService
        .adminAction(declineRequest)
        .subscribe((response) => {
          console.log("called");
          // this.snackBar.open("Declined", "OK");
          this.getInventoryRequest();
        });
    }
  }
  // ACCEPT NEW INVENTORY REQUEST
  acceptNewInvRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "New Inventory Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/new-inventory-request?filter=Approved Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      alertModalWithoutConfirm("success", "Request has been Approved!");
      // this.snackBar.open("Accepted", "OK");
      console.log("called");
      this.getNewInventory();
    });
  }

  //ACCEPT EXTEND REQUEST
  async acceptExtendRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Extend Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Extend Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      alertModalWithoutConfirm("success", "Request has been Approved!");
      console.log("called");
      this.getExtendData();
    });
  }

  async declineExtendRequest(requestId: any) {
    const acceptRequest = {
      action: "Rejected",
      requestId: requestId,
      requestType: "Extend Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/return-request?filter=Declined Extend Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      alertModalWithoutConfirm("success", "Request Declined!");
      // this.snackBar.open("Declined", "OK");
      console.log("called");
      this.getExtendData();
    });
  }

  //Show Remarks Form on decline click
  showDeclineForm: boolean = false;
  onDeclineButtonClick() {
    this.showDeclineForm = true;
    this.getInventoryReturnRequest();
  }

  gotoReturnRequest() {
    const backdrop = document.querySelector(".modal-backdrop");
    if (backdrop) {
      this.renderer.removeChild(document.body, backdrop);
    }
    this.router.navigate(["/inventory/return-request"]);
  }

  // REJECT NEW INVENTORY REQUEST
  async declineNewInvRequest(requestId: any) {
    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );
    const declineRequest = {
      action: "Rejected",
      requestId: requestId,
      requestType: "New Inventory Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/new-inventory-request?filter=Declined Request`,
    };
    this.inventoryService.adminAction(declineRequest).subscribe((response) => {
      console.log("called");
      // alertModalWithoutConfirm("warning", "Request Declined!");
      // this.snackBar.open("Declined", "OK");
      this.getNewInventory();
    });
  }

  //ACCEPT SERVICE REQUEST
  acceptNewServiceRequest(requestId: any) {
    const acceptRequest = {
      action: "Accept",
      requestId: requestId,
      requestType: "Service Request",
      redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Approved Request`,
    };
    this.inventoryService.adminAction(acceptRequest).subscribe((response) => {
      console.log("called");
      alertModalWithoutConfirm("success", "Request has been Approved!");
      // this.snackBar.open("Accepted", "OK");
      // window.location.reload();
      this.getServiceRequestData();
    });
  }

  // REJECT SERVICE REQUEST
  async declineServiceRequest(requestId: any) {
    const userConfirmed = await alertModalDecline(
      "Are you sure you want to decline this request?"
    );
    if (userConfirmed) {
      const declineRequest = {
        action: "Rejected",
        requestId: requestId,
        requestType: "Service Request",
        redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Declined Request`,
      };
      this.inventoryService.adminAction(declineRequest).subscribe(
        (response) => {
          console.log("called");
          // this.snackBar.open("Declined", "OK");
          this.getServiceRequestData();
        },
        (err) => {
          console.error("Error while declining the request", err);
          alertModalWithoutConfirm("error", "Failed to decline the request.");
        }
      );
    }
  }
  newInvReqId: any = {};
  assetReturnInv = [];
  totalAssetReturn: any;
  assetReturnReq() {
    const field: any = {
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
    };
    this.inventoryService.getAssetReturnRequest(field).subscribe((response) => {
      console.log("ASSET Return", response);
      this.assetReturnInv = response["data"].requests;
      this.totalAssetReturn = response["data"].totalCounts;
    });
  }
}
